import Transform from "@ember-data/serializer/transform";
import BioExamPrescription from "core/models/bio-exam/bio-exam-prescription";
export default class BioExamPrescriptionsTransform extends Transform {
  deserialize(serialized) {
    return serialized.map(item => new BioExamPrescription(item["id"], item["prescriptible"], item["selected"]));
  }
  serialize(deserialized) {
    const result = deserialized.map(item => {
      return {
        id: item.id,
        prescriptible: item.prescriptible,
        selected: item.selected
      };
    });
    return result;
  }
}